const abbreviateNumber = (num) =>
  Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(num);

export default abbreviateNumber;
